export default __webpack_public_path__ + "static/media/default.8fad31b5.jpg";